export default "__VITE_ASSET__694595dc__"